import styled from 'styled-components';

import { minWidth } from 'styles/media-queries';

import { spacer48, spacer64, spacer80 } from 'styles/spacers';

export const Container = styled.section`
  position: relative;
  margin-top: ${spacer48};
  ${minWidth.lg`
    margin-top: ${spacer80};
  `}
`;

export const GridPage = styled.div`
  display: grid;
  grid-gap: 16px;
  grid-template-columns: 1fr;

  ${minWidth.lg`
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 24px;
  `}
`;

export const CtaContainer = styled.div`
  display: flex;
  align-content: center;
  margin-top: ${spacer48};
  justify-content: left;

  ${minWidth.md`
    margin-top: ${spacer64};
    justify-content: center;
  `}
`;
